'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reselect = require('reselect');

var _defaults = require('../defaults');

var _defaults2 = _interopRequireDefault(_defaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Gets the confiration to be used for the application
 * @param {Map<*, *>} state The application state. Defaults to the default configuration if none is set
 * @returns {string} The configuration
 */
var getConfig = function getConfig(state) {
  return state.get('configs', _defaults2.default);
};

/**
 * Get the current configuration
 * @param {Map} state The redux state
 * @return {String} The application configuration
 */

var getConfigSelector = (0, _reselect.createSelector)([getConfig], function (config) {
  return config;
});

exports.default = getConfigSelector;
//# sourceMappingURL=config.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/redux-config-provider/dist/main/selectors/config.js
// module id = 514
// module chunks = 0